import AuthService from "@/services/AuthService";
import MyProfileService from "@/services/MyProfileService";

export default {
  namespaced: true,
  state: {
    user: null,
    isAuthenticated: false,
    isLoading: null,
    modelPermissionLoading: false
    
  },
  mutations: {
    saveUserData(state, payload) {
    
      // mutate state
      state.user = payload
      state.isAuthenticated = true;
      localStorage.setItem('user', JSON.stringify(payload));
    },

    authenticate(state, user) {
      state.isAuthenticated = true;
      state.user = user;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.isLoading = false;
      state.modelPermissionLoading = false;
      localStorage.removeItem('user');
    },

    loading(state, payload) {
      state.isLoading = payload;
    },

    permissionsLoading(state, payload) {
      state.modelPermissionLoading = payload;
    },
    
    reset(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      state.modelPermissionLoading = false;
    }

  },
  actions: {
    async checkAuth({ commit, state }) {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      if (storedUser) {
        commit('saveUserData', storedUser);
        return;
      }
      try {
        commit('loading', true);
        commit('permissionsLoading', true)

        const response = await AuthService.checkAuth();
        console.log("response", response)

        if (!response.data?.client_id) {
          const profileResponse = await MyProfileService.getUserProfile();
          // this.userProfile = response.data;
          console.log("userProfile", this.userProfile)

          if(profileResponse.data?.employee_personal_information["profile_picture"] && response.data) {
                response.data["profile_picture"] = profileResponse.data?.employee_personal_information["profile_picture"]
          }
        }


        if (response.data) {
          commit('authenticate', response.data);
        } else {
          commit('logout');
        }

        commit('loading', false);
        commit('permissionsLoading', false)

      } catch (error) {
        console.error('Authentication check failed:', error);
        // console.log("here", this.$router)
        commit('logout');
        
        // commit('loading', false);

      }
    },
    saveUserData(context, payload) {
      context.commit('saveUserData', payload)
    },

    resetState(context) {
      context.commit('reset')
    },


    loading(context, payload) {
      context.commit('loading', payload)
    },

    permissionsLoading(context, payload) {
      context.commit('permissionsLoading', payload)
    },


  },

  getters: {
    userName(state) {
      return state.user?.name || ''
    },

    userRole(state) {
      return state.user?.role || ''
    },

    userPermissions(state) {
      return state.user?.permission || []
    },

    isClientUser(state) {
      return !!state.user?.client_id
    }
  }
}